<template>
  <!-- Port of the Laravel Pro panel single select (fyxify resources/js/components/partials/proSingleSelectDropdown.vue):
       button shows the picked option (or "Select <field>") with a ✕ to clear, list with a check box per option and
       optional search. Vue 3 v-model = the option value (null = none). The list overlays the fields below. -->
  <div ref="root" class="relative w-full font-roboto">
    <div class="relative">
      <button type="button" :disabled="disabled"
        class="w-full h-[40px] pl-[14px] pr-[56px] rounded-[8px] border-1 bg-[#fff] text-left text-[14px] truncate disabled:bg-[#F7F8FA] disabled:cursor-not-allowed"
        :class="[isOpen ? 'border-[#8479E1]' : 'border-[#E1E5EF]', selected ? 'text-[#333333]' : 'text-[#999999]']"
        @click="toggle">
        {{ selected ? selected[labelKey] : `Select ${fieldName}` }}
      </button>
      <div class="absolute top-0 right-0 h-full pr-[14px] flex items-center gap-[8px]">
        <button v-if="!disabled && selected" type="button" aria-label="Clear" class="p-0 border-0 bg-transparent flex" @click="clear">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" stroke="#EE5851" stroke-width="2.6" stroke-linecap="round" /></svg>
        </button>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true" class="cursor-pointer transition-transform"
          :class="{ 'rotate-180': isOpen }" @click="toggle">
          <path d="M6 9l6 6 6-6" stroke="#666666" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <div v-if="isOpen" class="absolute left-0 right-0 top-full z-30 mt-[6px] p-[8px] flex flex-col gap-[4px] rounded-xl border-1 border-[#E1E5EF] bg-[#fff] shadow-[0px_4px_12px_0px_#0000001A]">
      <div v-if="isSearchable" class="relative">
        <svg class="absolute left-[10px] top-1/2 -translate-y-1/2 pointer-events-none" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="11" cy="11" r="7" stroke="#999999" stroke-width="2" /><path d="m20 20-3.5-3.5" stroke="#999999" stroke-width="2" stroke-linecap="round" />
        </svg>
        <input v-model="searchQuery" type="text" placeholder="Search..."
          class="w-full h-[36px] pl-[34px] pr-[10px] rounded-[5px] border-1 border-[#E1E5EF] text-[13px] text-[#333333] outline-none focus:border-[#8479E1]">
      </div>
      <div class="max-h-60 overflow-auto">
        <label v-for="option in filteredOptions" :key="option[valueKey]" class="pmsRow"
          :class="{ picked: isSelected(option) }" @click.prevent="pick(option)">
          <span class="pmsBox" :class="{ on: isSelected(option) }"><svg v-if="isSelected(option)" viewBox="0 0 20 20" fill="#fff"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg></span>
          {{ option[labelKey] }}
        </label>
        <p v-if="!filteredOptions.length" class="m-0 py-2 text-center text-[13px] text-[#999999]">No results found</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: [String, Number, Boolean], default: null },
    options: { type: Array, default: () => [] },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "value" },
    fieldName: { type: String, default: "" },
    isSearchable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  data() {
    return { isOpen: false, searchQuery: "" };
  },
  computed: {
    selected() {
      if (this.modelValue == null || this.modelValue === "") return null;
      return this.options.find(o => String(o[this.valueKey]) === String(this.modelValue)) || null;
    },
    filteredOptions() {
      if (!this.searchQuery) return this.options;
      const q = this.searchQuery.toLowerCase();
      return this.options.filter(o => String(o[this.labelKey]).toLowerCase().includes(q));
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onOutside);
  },
  beforeUnmount() {
    document.removeEventListener("mousedown", this.onOutside);
  },
  methods: {
    isSelected(option) {
      return this.selected && String(this.selected[this.valueKey]) === String(option[this.valueKey]);
    },
    emit(value) {
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
    },
    // like Laravel: picking the selected one again clears it
    pick(option) {
      this.emit(this.isSelected(option) ? null : option[this.valueKey]);
      this.isOpen = false;
      this.searchQuery = "";
    },
    clear() {
      this.emit(null);
    },
    toggle() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;
      this.searchQuery = "";
    },
    onOutside(e) {
      if (this.isOpen && this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.isOpen = false;
        this.searchQuery = "";
      }
    },
  },
};
</script>
